export { default as theme } from 'prismjs/themes/prism-okaidia.css';
